import {axiosInstance} from "../axios";
import {login_apis} from "../ApiConst";

export const User_LogIn = async (loginData) => {
  const { mobile_number, registered_device, device_type } = loginData;
  const params = {
    mobile_number,
    registered_device,
    device_type,
  };
  return await axiosInstance.post(login_apis.login, params);
};


export const login_OTP = async (userid, enteredOtp) => {
  let params = {
    user_id: userid,
    otp: enteredOtp,
  };

  return await axiosInstance.post(login_apis.verify_otp, params);
};

